// extracted by mini-css-extract-plugin
module.exports = {"button":"Zero_button__1rMAA","text":"Zero_text__2c3BJ"};